import $c5Csu$intltagarAEmjs from "../intl/tag/ar-AE.mjs";
import $c5Csu$intltagbgBGmjs from "../intl/tag/bg-BG.mjs";
import $c5Csu$intltagcsCZmjs from "../intl/tag/cs-CZ.mjs";
import $c5Csu$intltagdaDKmjs from "../intl/tag/da-DK.mjs";
import $c5Csu$intltagdeDEmjs from "../intl/tag/de-DE.mjs";
import $c5Csu$intltagelGRmjs from "../intl/tag/el-GR.mjs";
import $c5Csu$intltagenUSmjs from "../intl/tag/en-US.mjs";
import $c5Csu$intltagesESmjs from "../intl/tag/es-ES.mjs";
import $c5Csu$intltagetEEmjs from "../intl/tag/et-EE.mjs";
import $c5Csu$intltagfiFImjs from "../intl/tag/fi-FI.mjs";
import $c5Csu$intltagfrFRmjs from "../intl/tag/fr-FR.mjs";
import $c5Csu$intltagheILmjs from "../intl/tag/he-IL.mjs";
import $c5Csu$intltaghrHRmjs from "../intl/tag/hr-HR.mjs";
import $c5Csu$intltaghuHUmjs from "../intl/tag/hu-HU.mjs";
import $c5Csu$intltagitITmjs from "../intl/tag/it-IT.mjs";
import $c5Csu$intltagjaJPmjs from "../intl/tag/ja-JP.mjs";
import $c5Csu$intltagkoKRmjs from "../intl/tag/ko-KR.mjs";
import $c5Csu$intltagltLTmjs from "../intl/tag/lt-LT.mjs";
import $c5Csu$intltaglvLVmjs from "../intl/tag/lv-LV.mjs";
import $c5Csu$intltagnbNOmjs from "../intl/tag/nb-NO.mjs";
import $c5Csu$intltagnlNLmjs from "../intl/tag/nl-NL.mjs";
import $c5Csu$intltagplPLmjs from "../intl/tag/pl-PL.mjs";
import $c5Csu$intltagptBRmjs from "../intl/tag/pt-BR.mjs";
import $c5Csu$intltagptPTmjs from "../intl/tag/pt-PT.mjs";
import $c5Csu$intltagroROmjs from "../intl/tag/ro-RO.mjs";
import $c5Csu$intltagruRUmjs from "../intl/tag/ru-RU.mjs";
import $c5Csu$intltagskSKmjs from "../intl/tag/sk-SK.mjs";
import $c5Csu$intltagslSImjs from "../intl/tag/sl-SI.mjs";
import $c5Csu$intltagsrSPmjs from "../intl/tag/sr-SP.mjs";
import $c5Csu$intltagsvSEmjs from "../intl/tag/sv-SE.mjs";
import $c5Csu$intltagtrTRmjs from "../intl/tag/tr-TR.mjs";
import $c5Csu$intltagukUAmjs from "../intl/tag/uk-UA.mjs";
import $c5Csu$intltagzhCNmjs from "../intl/tag/zh-CN.mjs";
import $c5Csu$intltagzhTWmjs from "../intl/tag/zh-TW.mjs";

var $c861dd473ab3d00c$exports = {};


































$c861dd473ab3d00c$exports = {
    "ar-AE": $c5Csu$intltagarAEmjs,
    "bg-BG": $c5Csu$intltagbgBGmjs,
    "cs-CZ": $c5Csu$intltagcsCZmjs,
    "da-DK": $c5Csu$intltagdaDKmjs,
    "de-DE": $c5Csu$intltagdeDEmjs,
    "el-GR": $c5Csu$intltagelGRmjs,
    "en-US": $c5Csu$intltagenUSmjs,
    "es-ES": $c5Csu$intltagesESmjs,
    "et-EE": $c5Csu$intltagetEEmjs,
    "fi-FI": $c5Csu$intltagfiFImjs,
    "fr-FR": $c5Csu$intltagfrFRmjs,
    "he-IL": $c5Csu$intltagheILmjs,
    "hr-HR": $c5Csu$intltaghrHRmjs,
    "hu-HU": $c5Csu$intltaghuHUmjs,
    "it-IT": $c5Csu$intltagitITmjs,
    "ja-JP": $c5Csu$intltagjaJPmjs,
    "ko-KR": $c5Csu$intltagkoKRmjs,
    "lt-LT": $c5Csu$intltagltLTmjs,
    "lv-LV": $c5Csu$intltaglvLVmjs,
    "nb-NO": $c5Csu$intltagnbNOmjs,
    "nl-NL": $c5Csu$intltagnlNLmjs,
    "pl-PL": $c5Csu$intltagplPLmjs,
    "pt-BR": $c5Csu$intltagptBRmjs,
    "pt-PT": $c5Csu$intltagptPTmjs,
    "ro-RO": $c5Csu$intltagroROmjs,
    "ru-RU": $c5Csu$intltagruRUmjs,
    "sk-SK": $c5Csu$intltagskSKmjs,
    "sl-SI": $c5Csu$intltagslSImjs,
    "sr-SP": $c5Csu$intltagsrSPmjs,
    "sv-SE": $c5Csu$intltagsvSEmjs,
    "tr-TR": $c5Csu$intltagtrTRmjs,
    "uk-UA": $c5Csu$intltagukUAmjs,
    "zh-CN": $c5Csu$intltagzhCNmjs,
    "zh-TW": $c5Csu$intltagzhTWmjs
};


export {$c861dd473ab3d00c$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
